import React, { lazy, Suspense } from "react";
import PropTypes from "prop-types";
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import NavBar from "../Components/NavBar";
import ErrorBoundary from "../ErrorBoundary";
import Login from "../Components/Login";
import Callback from "../Okta/Callback";
import SecureRouteWrapper from "./SecureRouteWrapper";
import Logout from "../Components/Logout";

// Lazy-loaded pages
const Dashboard = lazy(() => import("../Pages/Dashboard"));
const Candidate = lazy(() => import("../Pages/CandidateUpload/Tabs"));
const CandidateList = lazy(() => import("../Pages/CandidateList/CandidateList/CandidateList"));
const GenerateReport = lazy(() => import("../Pages/Reports/GenerateReport"));
const Rereview = lazy(() => import("../Pages/Re-review/Rereview"));
const ImposterDetection = lazy(() => import("../Pages/CandidateList/ImposterDetection/ImposterDetection"));
const SettingPage = lazy(() => import("../Pages/Setting/SettingPage"));
const NotificationManagement = lazy(() => import("../Pages/NotificationManagement"));
const AuditReport = lazy(() => import("../Pages/AuditReport"));

// Error boundary + Suspense wrapper
const withErrorBoundary = (WrappedComponent) => {
  return function ErrorBoundaryWrapper(props) {
    return (
      <ErrorBoundary>
        <Suspense fallback={<div>Loading...</div>}>
          <WrappedComponent {...props} />
        </Suspense>
      </ErrorBoundary>
    );
  };
};

// Layout wrapper for NavBar + nested routes
const MainLayout = () => (
  <>
    <NavBar />
  </>
);

// Routes config
export const router = createBrowserRouter([
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/logout",
    element: <Logout />,
  },
  {
    path: "/login/callback",
    element: <Callback />,
  },
  {
    path: "/v0",
    element: <MainLayout />,
    children: [
      {
        path: "dashboard",
        element: <SecureRouteWrapper component={withErrorBoundary(Dashboard)} />,
      },
      {
        path: "candidate",
        element: <SecureRouteWrapper component={withErrorBoundary(Candidate)} />,
      },
      {
        path: "candidatelist",
        element: <SecureRouteWrapper component={withErrorBoundary(CandidateList)} />,
      },
      {
        path: "reports",
        element: <SecureRouteWrapper component={withErrorBoundary(GenerateReport)} />,
      },
      {
        path: "rereview",
        element: <SecureRouteWrapper component={withErrorBoundary(Rereview)} />,
      },
      {
        path: "candidatelist/imposterDetection/:id",
        element: <SecureRouteWrapper component={withErrorBoundary(ImposterDetection)} />,
      },
      {
        path: "setting",
        element: <SecureRouteWrapper component={withErrorBoundary(SettingPage)} />,
      },
      {
        path: "auditreport",
        element: <SecureRouteWrapper component={withErrorBoundary(AuditReport)} />,
      },
    ],
  },
  {
    path: "/",
    element: <Navigate to="/v0/dashboard" replace />,
  },
]);


export function RouterProviderWrapper({ children }) {
  return <RouterProvider router={router}>{children}</RouterProvider>;
}

RouterProviderWrapper.propTypes = {
  children: PropTypes.node,
};
